import React, { useState } from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import { BoxArrowUpRight } from 'react-bootstrap-icons'
import UserImage from '../image'
import UserLastFirstName from '../last-first-name'
import UserGrade from '../grade'
import UserRole from '../role-field'
import useClientLocation from '../../../hooks/use-client-location'

const UserCard = ({
    user = {}
}) => {
    const { userProfile } = useClientLocation()
    return (
        <Col xs={12} sm={12} md={12} lg={6} xl={4} style={{ padding: '10px'}}>
            <Card border='primary' text='primary' tag='a' onClick={() => userProfile(user.id)} style={{ cursor: 'pointer' }}>
                <Card.Body>
                    <Row noGutters>
                        <Col md={1} lg={2} ><UserImage user={user} /></Col>
                        <Col md={10} lg='auto' className='content'>
                            <div className='card-text user-name'>
                                <UserLastFirstName user={user} />
                            </div>
                            <div className='card-text'><UserRole user={user} /></div>
                            <div className='card-text'><UserGrade user={user} /></div>
                        </Col>
                        <Col className='text-right'>
                            <BoxArrowUpRight onClick={() => userProfile(user.id)} />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Col>
    )
}

export default UserCard